<template>
    <div>
        <hr class="my-4"/>
        <h3 class="text-uppercase text-center">
            <em class="text-danger">{{ fullname }}</em>'s Information
        </h3>
        <hr class="my-4"/>

        <div class="col-lg-12">
            <div class="card shadow">
                <div class="table-responsive">
                    <base-table
                        class="table align-items-center table-flush"
                        thead-classes="thead-light"
                        tbody-classes="list"
                        :data="records"
                    >
                        <template slot="columns">
                            <th>Staff Name</th>
                            <th>Previous Name</th>
                            <th v-if="(type == 'consultant')">Folio No</th>
                            <th v-if="(type == 'consultant')">Registration No <br> / AQ Number</th>
                            <th>Rank / Position</th>
                            <th v-if="(type == 'consultant')">Department <br>/ File No</th>
                            <th v-if="(type == 'staff')">Department / File No</th>
                        </template>

                        <template
                            slot-scope="{row}"
                        >
                        <td class="text-capitalize">
                            {{ getFullName(row) }}
                        </td>
                        <td class="text-capitalize">
                            {{ row.previous_name ? row.previous_name : 'N/A' }}
                        </td>
                        <td v-if="(type == 'consultant')">{{ row.folio_number }}</td>
                        <td v-if="(type == 'consultant')">
                            {{ row.reg_no }} <br>
                            <badge type="success">{{ row.aq_no }}</badge>
                        </td>
                        <td class="text-capitalize">
                            {{ row.rank ? row.rank : 'N/A' }} <br>
                            <badge type="dark">{{ row.position ? row.position : 'N/A'}}</badge>
                        </td>
                        <td v-if="(type == 'consultant')">
                            {{ row.department ? row.department.name : 'N/A' }}<br>
                            <badge type="info">{{ row.file_no ? row.file_no : 'N/A'}}</badge>
                        </td>
                        <td v-if="(type == 'staff')">
                            {{ row.department ? row.department : 'N/A' }}<br>
                            <badge type="info">{{ row.file_no ? row.file_no : 'N/A'}}</badge>
                        </td>

                        </template>

                    </base-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Consultant',
        props: ['records', 'fullname', 'type'],
        methods: {
            getFullName(record) {
                if(record) {
                    let name = record.first_name;
                    name += record.other_name ? ' ' + record.other_name : '';
                    name += ' ' + record.surname;
                    return name;
                } else {
                    return 'N/A';
                }
            }
        }
    }
</script>

<style>
.right {
    float: right;
}
</style>

<style>
    .form-control-label {
        width: 100%;
    }
</style>